<template>
    <div ref="slider" :class="[{'disabled': disabled}, 'base-slider']">
        <div @mousedown="startDrag(0, $event)"
             ref="leftCircle"
             class="left-btn btn"></div>
        <div ref="selectedLine" class="selected-line"></div>
        <div @mousedown="startDrag(1, $event)"
             ref="rightCircle"
             class="right-btn btn"></div>
    </div>
</template>

<script>

    export default {
        name: "base-slider",
        data() {
            return {
                dragStatus: false,
                whichCircle: null,
                startX: null,
                leftCircleX: 0,
                rightCircleX: 0,
                sliderWidth: null,
                differenceSize: 0,
                dataValue: [],
                x1: 0,
                x2: 0,
            }
        },
        props: {
            size: {
                type: Array,
                default: () => []
            },
            value: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.dataValue = this.value.slice()
            let x = this.size[0];
            let y = this.size[1];
            this.differenceSize = x < y ? y - x : x - y

            this.sliderWidth = this.$refs.slider.offsetWidth
            this.x2 = this.$refs.slider.offsetWidth
            window.addEventListener("mousemove", this.drag);
            window.addEventListener("mouseup", this.stopDrag);
            let x1 = this.value[0]
            let x2 = this.value[1]
            this.setValue(x1, x2);

            // this.$refs.slider.addEventListener("resize", this.resize)
        },
        methods: {
            // resize() {
            //     console.log(111);
            // },
            setValue(x1, x2) {
                let left = (x1 - this.size[0]) / (this.differenceSize / 100);
                left = left * (this.sliderWidth / 100);
                if (this.size[0] === x1) left = 0;
                this.$refs.leftCircle.style.left = `${left}px`;
                this.$refs.selectedLine.style.left = `${left}px`;
                this.x1 = left;

                let right = (x2 - this.size[0]) / (this.differenceSize / 100);
                right = right * (this.sliderWidth / 100);
                if (this.size[1] === x2) right = this.sliderWidth;
                this.$refs.rightCircle.style.left = `${right}px`;
                this.$refs.selectedLine.style.right = `${this.sliderWidth - right}px`;
                this.x2 = right
            },
            startDrag(circle, event) {
                if (this.size[0] === this.size[1]) {
                    return
                }

                this.startX = event.x
                this.dragStatus = true;
                this.whichCircle = circle;
                this.leftCircleX = parseInt(this.$refs.leftCircle.style.left) || 0
                this.rightCircleX = parseInt(this.$refs.rightCircle.style.left) || 0
                if (circle) {
                    this.$refs.rightCircle.classList.add('active')
                } else {
                    this.$refs.leftCircle.classList.add('active')
                }
            },
            stopDrag() {
                if (this.size[0] === this.size[1]) {
                    return
                }

                let left = this.x1 / (this.sliderWidth / 100)
                left = Math.round(left * (this.differenceSize / 100))

                let right = this.x2 / (this.sliderWidth / 100)
                right = Math.round(right * (this.differenceSize / 100))
                if (this.dragStatus) {
                    this.$emit("change", [left + this.size[0], right + this.size[0]])
                }

                this.dragStatus = false;
                this.whichCircle = null;
                this.startX = null;
                this.$refs.rightCircle.classList.remove('active')
                this.$refs.leftCircle.classList.remove('active')
            },
            drag(event) {
                if (this.dragStatus) {

                    if (this.whichCircle) {
                        this.$refs.leftCircle.style.zIndex = 1;
                        this.$refs.rightCircle.style.zIndex = 2;

                        let size = this.sliderWidth + (event.x - this.startX) - ((this.rightCircleX || this.rightCircleX === 0) ? (this.sliderWidth - this.rightCircleX) : 20);

                        if (size >= 0 && size <= this.sliderWidth && this.leftCircleX <= size) {
                            this.x2 = size;
                            this.$refs.rightCircle.style.left = `${size}px`
                            this.$refs.selectedLine.style.right = `${this.sliderWidth - size}px`
                        } else if (size > this.sliderWidth) {
                            this.x2 = this.sliderWidth;
                            this.$refs.rightCircle.style.left = `${this.sliderWidth}px`
                            this.$refs.selectedLine.style.right = `${0}px`
                        } else if (size <= this.x1) {
                            this.x2 = this.x1;
                            this.$refs.rightCircle.style.left = `${this.x1}px`
                            this.$refs.selectedLine.style.right = `${this.sliderWidth}px`
                        }
                    } else {
                        this.$refs.rightCircle.style.zIndex = 1;
                        this.$refs.leftCircle.style.zIndex = 2;

                        let size = this.leftCircleX + event.x - this.startX;

                        if (size >= 0 && size <= this.sliderWidth && (this.rightCircleX !== 0 ? this.rightCircleX >= size : true)) {
                            this.x1 = size;
                            this.$refs.leftCircle.style.left = `${size}px`
                            this.$refs.selectedLine.style.left = `${size}px`
                        } else if (size < 0) {
                            this.x1 = 0;
                            this.$refs.leftCircle.style.left = `${0}px`
                            this.$refs.selectedLine.style.left = `${0}px`
                        } else if (size > this.x2) {
                            this.x1 = this.x2;
                            this.$refs.leftCircle.style.left = `${this.x2}px`
                            this.$refs.selectedLine.style.left = `${this.x2}px`
                        }
                    }
                    this.emitValue(this.x1, this.x2)
                }
            },
            emitValue(x1, x2) {
                let left = x1 / (this.sliderWidth / 100)
                left = Math.round(left * (this.differenceSize / 100))

                let right = x2 / (this.sliderWidth / 100)
                right = Math.round(right * (this.differenceSize / 100))

                this.$emit("input", [left + this.size[0], right + this.size[0]])
            }
        },
        watch: {
            value(val) {
                let x1 = val[0];
                let x2 = val[1];
                this.setValue(x1, x2);
            },
            size(val,oldVal) {
                let x = val[0];
                let y = val[1];
                this.differenceSize = x < y ? y - x : x - y;

                if (oldVal[1] === 0) {
                    this.value[0] = x;
                    this.value[1] = y;
                }
                let x1 = this.value[0];
                let x2 = this.value[1];
                this.setValue(x1, x2);
            }
        },
        beforeDestroy() {
            window.removeEventListener("mousemove", this.drag);
            window.removeEventListener("mouseup", this.stopDrag);
        }
    }
</script>

<style scoped>
    .base-slider {
        position: relative;
        height: 2px;
        background-color: var(--lighten-4-color);
    }
    .base-slider .selected-line{
        position: absolute;
        top: calc(50% - 2px);
        left: 0;
        right: 0;
        background-color: var(--primary-color);
        height: 4px;
    }
    .base-slider .btn{
        position: absolute;
        top: calc(50% - 10px);
        width: 20px;
        height: 20px;
        background-color: var(--primary-color);
        box-sizing: border-box;
        border: 3px solid var(--white-color);
        border-radius: 50%;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
        cursor: pointer;
        z-index: 1;
    }
    .base-slider .btn.active {
        width: 22px;
        height: 22px;
        top: calc(50% - 11px);
    }
    .base-slider .left-btn{
        left: 0;
    }
    .base-slider .right-btn {
        left: calc(100% - 20px);
    }
    .disabled {
        opacity: .5;
    }
    .disabled .btn {
        cursor: default;
    }
</style>
